/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinTopGainerListRequest = {
    type?: AptosCoinTopGainerListRequest.type;
    size?: number;
};

export namespace AptosCoinTopGainerListRequest {

    export enum type {
        ALL = 'ALL',
        MEME = 'MEME',
    }


}

